import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';
import { FDBodyText } from '@facet-wealth/design';


export default buildFacetDesignOverride()
  .nameOverride('location', {
    _component: () => RichTextDisplay,
  }, overrideReadOnly)
  .nameOverride('callToAction', {
    _component: () => FDBodyText,
  }, overrideReadOnly);
